
import Vue from 'vue';
import FeatureTourMedia from '@/featureTour/components/FeatureTourMedia.vue';
import { USE_3D_TOOLTIP_VIDEO_URL } from './use3DTooltipMedia';

export default Vue.extend({
	name: 'Use3DTooltipCard',
	components: { FeatureTourMedia },
	props: {
		title: { type: String, default: 'Get Image from 3D Model' },
		description: {
			type: String,
			default: 'Choose your 3D model to upload, position it in the 3D viewer, and pick a background: transparent, a solid color, or an image from your library or uploads.',
		},
		mediaUrl: { type: String, default: USE_3D_TOOLTIP_VIDEO_URL },
	},
});
